import { actionCreator, asyncActionsCreator } from '../common/utils';
import { TaskCategoryDto, WorkloadTask } from 'shovel-lib/types';
import { SidebarItemType } from './types';
import { ListMove } from '../../utils/taskListOrder';

const asyncActions = asyncActionsCreator('@@workload');
const action = actionCreator('@@workload');

export const getWorkload = asyncActions<number | undefined, WorkloadTask[], string>('GET_WORKLOAD');

export const resetAddedWorkloadTasks = action<void>('RESET_ADDED_WORKLOAD_TASKS');

/** Load the Task List again without its loading skeleton (it opened, or sessions changed elsewhere). */
export const refreshWorkload = action<void>('REFRESH_WORKLOAD');

export const startCourseWorkloadListener = action<undefined>('START_COURSE_WORKLOAD_LISTENER');

export const stopCourseWorkloadListener = action<undefined>('STOP_COURSE_WORKLOAD_LISTENER');

export const selectCommitment = action<{
  id: string | number;
  type: SidebarItemType;
  name: string;
  colorHex?: string;
} | void>('SELECT_COMMITMENT');

// action to stop the forced skeleton
export const selectCommitmentSuccess = action<void>('SELECT_COMMITMENT_SUCCESS');

export const toggleCourseSection = action<{ id: string | number; expand: boolean }>('TOGGLE_COURSE_SECTION');

export const setCourseCategorizing = action<{ courseId: number; categorizing: boolean }>('SET_COURSE_CATEGORIZING');

// Set only when auto-categorize is triggered from inside the Task Estimator (which we close
// first, since its category picker can't create new categories) so the floating status panel
// can offer a clear way back in once categorization finishes.
export const setPendingEstimateReminder = action<{ courseId: number; pending: boolean }>('SET_PENDING_ESTIMATE_REMINDER');

/**
 * "Sort: By hand": a task dragged between two others. `was`: where it stood before (its neighbours then), for the
 * Undo; none when this is the Undo itself. Success: the numbers the server saved, by task.
 */
export const moveTaskInList = asyncActions<
  { move: ListMove; was: { after: number | null; before: number | null } | null },
  { id: number; listOrder: number }[],
  string
>('MOVE_TASK_IN_LIST');
